export default "__VITE_ASSET__DwDl1CVT__"